import { request, service } from '@/utils/request'

/**
 * 人员日志
 */

// 列表
export const getEmpLogList = (data) => {
	return request({
		url: '/employeelog/getEmpLogList',
		method: 'post',
		data: {
			data
		}
	})
}

/**
 * 营业日志
 */

// 列表
export const getYylogList = (data) => {
	return request({
		url: '/yylog/getYylogList',
		method: 'post',
		data: {
			data
		}
	})
}
// 详情
export const getYylogItem = (id) => {
	return request({
		url: '/yylog/getYylogItem',
		method: 'post',
		data: {
			data: {
				id
			}
		}
	})
}
// 新增
export const addYylogItem = (data) => {
	return request({
		url: '/yylog/addYylogItem',
		method: 'post',
		data: {
			data
		}
	})
}
// 修改
export const saveYylogItem = (data) => {
	return request({
		url: '/yylog/saveYylogItem',
		method: 'post',
		data: {
			data
		}
	})
}
/**
 * 可疑情况
 */

// 列表
export const getkyqklist = (data) => {
	return request({
		url: '/kyqk/getkyqklist',
		method: 'post',
		data: {
			data
		}
	})
}
// 详情
export const getkyqkitem = (id) => {
	return request({
		url: '/kyqk/getkyqkitem',
		method: 'post',
		data: {
			data: { id }
		}
	})
}
// 新增
export const addKyqkItem = (data) => {
	return request({
		url: '/kyqk/addKyqkItem',
		method: 'post',
		data: {
			data
		}
	})
}
// 修改
export const saveKyqkItem = (data) => {
	return request({
		url: '/kyqk/saveKyqkItem',
		method: 'post',
		data: {
			data
		}
	})
}
/**
 * 公安机关日常检查
 */

// 列表
export const getDaliyList = (data) => {
	return request({
		url: '/dailycheck/getDaliyList',
		method: 'post',
		data: {
			data
		}
	})
}
// 详情
export const getDaliyItem = (id) => {
	return request({
		url: '/dailycheck/getDaliyItem',
		method: 'post',
		data: {
			data: { id }
		}
	})
}
// 新增
export const addDaliyItem = (data) => {
	return request({
		url: '/dailycheck/addDaliyItem',
		method: 'post',
		data: {
			data
		}
	})
}

// 打卡
export const addEmpLogItem = (data) => {
	return request({
		url: '/employeelog/addEmpLogItem',
		method: 'post',
		data: {
			data
		}
	})
}
//读卡
export const addEmp = (data) => {
	return request({
		url: '/employee/addEmp',
		method: 'post',
		data: {
			data
		}
	})
}

// 管辖机构
export const getzagldw = (data) => {
	return request({
		url: '/common/getzagldw',
		method: 'post',
		data: {
			data
		}
	})
}

// 获取日常检查 - 检查类型字典
export function getJCLX() {
	return request({
		url: 'common/dict',
		method: 'post',
		data: {
			data: {
				typename: 'JCLX'
			}
		}
	})
}


// 运维管理 --- 精细化

// 
export function getTypes() {
	return new Promise((resolve, reject) => {
		resolve({
			data: [
				{ bscode: "02", bsname: "维护" },
				{ bscode: "03", bsname: "回访" },
				{ bscode: "05", bsname: "远程维护" },
			]
		})
		reject('失败')
	})
}
// 列表

export function getRefined(nohotel, page, pagesize, sdate, edate) {
	return service({
		// aopenViewyl 娱乐 || aopenViewdd   典当  || 移动 aopenViewapp
		url: `open.ashx?action=aopenViewyl
		&nohotel=${nohotel}
		&page=${page}&pagesize=${pagesize}
		${sdate ? "&sdate=" + sdate : ''}
		${edate ? "&edate=" + edate : ''}`,
		method: 'get',
	})
}

// 详情

export function getRefinedDetails(id) {
	return service({
		url: `open.ashx?action=appopenShow&id=${id}`,
		method: 'get',
	})
}

// 新增

export function addRefined(data) {
	return service({
		url: 'open.ashx' + encodeURI(`?action=${data.action}&category=${data.category}&hotelCode=${data.hotelCode}&contacts=${data.contacts}&tel=${data.tel}&describe=${data.describe}`),
		method: 'post',
	})
}
// 更新

export function updataRefined(data) {
	return service({
		url: 'open.ashx' + encodeURI(`?action=${data.action}&cwid=${data.cwid}&types=${data.types}&confirmren=${data.confirmren}&confirmtel=${data.confirmtel}&pfjishu=${data.pfjishu}&pfsd=${data.pfsd}&pftd=${data.pftd}`),
		method: 'post',
	})
}